import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "validation-text"
}
const _hoisted_2 = {
  key: 1,
  class: "small text-muted"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "form-group checkbox"
}
const _hoisted_7 = {
  class: "form-label",
  for: "vat_number"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "small text-muted" }
const _hoisted_10 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_11 = {
  key: 1,
  class: "form-group"
}
const _hoisted_12 = { class: "form-label" }
const _hoisted_13 = { class: "small text-muted" }
const _hoisted_14 = {
  key: 2,
  class: "form-group"
}
const _hoisted_15 = { class: "border rounded p-2 mt-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = {
  key: 1,
  class: "small text-muted"
}
const _hoisted_21 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_22 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_23 = {
  key: 3,
  class: "d-flex flex-wrap align-items-center mt-2"
}
const _hoisted_24 = {
  key: 1,
  class: "text-success mr-3 mb-1"
}
const _hoisted_25 = {
  key: 3,
  class: "form-group checkbox"
}
const _hoisted_26 = {
  class: "form-label",
  for: "vat_skipped"
}
const _hoisted_27 = { class: "input-area" }
const _hoisted_28 = { class: "label-area" }
const _hoisted_29 = {
  key: 4,
  class: "form-group checkbox"
}
const _hoisted_30 = {
  class: "form-label",
  for: "accept_terms"
}
const _hoisted_31 = { class: "input-area" }
const _hoisted_32 = { class: "label-area" }
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 5,
  class: "form-group checkbox"
}
const _hoisted_35 = {
  class: "form-label",
  for: "accept_var_terms"
}
const _hoisted_36 = { class: "input-area" }
const _hoisted_37 = { class: "label-area" }
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 6,
  class: "form-group checkbox"
}
const _hoisted_40 = {
  class: "form-label",
  for: "cart_clearance"
}
const _hoisted_41 = { class: "input-area" }
const _hoisted_42 = { class: "label-area" }
const _hoisted_43 = {
  key: 7,
  class: "form-group checkbox"
}
const _hoisted_44 = {
  class: "form-label",
  for: "trial_terms"
}
const _hoisted_45 = { class: "input-area" }
const _hoisted_46 = { class: "label-area" }
const _hoisted_47 = { class: "text-right" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 8,
  class: "small text-muted text-right"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.items_in_cart.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cart-validation", { 'cart-validation--split': !$setup.confirmation_requested }])
      }, [
        _createElementVNode("div", null, [
          (!$setup.confirmation_requested)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.__("Your choice")), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.trial)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.__("Evaluation is free, no payment required")), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", null, [
          _createCommentVNode(" A guest identifies before ordering. GuestOrderIdentification is that step:\n\t\t\t     today a link to log in, later the email-code entry, with nothing around it\n\t\t\t     to change. "),
          ($setup.is_guest)
            ? (_openBlock(), _createBlock($setup["GuestOrderIdentification"], { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createCommentVNode(" The basket kept as a quote (quotes.create_quote); the basket stays as it is. "),
                  (!$setup.confirmation_requested)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary mr-2",
                        onClick: _cache[0] || (_cache[0] = $event => ($setup.make_quote())),
                        disabled: $setup.quote_requested || $setup.contact_changing
                      }, _toDisplayString(_ctx.__("Make a Quote")), 9 /* TEXT, PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true),
                  (!$setup.confirmation_requested)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary mr-2",
                        onClick: $setup.ask_for_trial_confirmation
                      }, _toDisplayString(_ctx.__("For 15 days trial period")), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (!$setup.confirmation_requested)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-primary",
                        onClick: $setup.ask_for_confirmation
                      }, _toDisplayString(_ctx.__("To order")), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.confirmation_requested && !$setup.stored_vat_number && !$setup.trial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.__("Your company's VAT Number")), 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "vat_number",
                        class: "form-control",
                        placeholder: "BE1234567890",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.vat_number) = $event)),
                        disabled: $setup.vat_state === 'checking'
                      }, null, 8 /* PROPS */, _hoisted_8), [
                        [_vModelText, $setup.vat_number]
                      ]),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.__("With your VAT number, we directly have your company details")), 1 /* TEXT */),
                      ($setup.vat_check_supported)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.__("Your VAT number will be validated in the process")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" The customer's own number, not validated yet: shown as it is, the one VIES is asked about. "),
                ($setup.confirmation_requested && $setup.stored_vat_number && !$setup.trial && $setup.vat_step)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.__("Your company's VAT Number")), 1 /* TEXT */),
                      _createElementVNode("div", null, _toDisplayString($setup.stored_vat_number), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.__("Your VAT number will be validated in the process")), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" What VIES answered (check_vat_number), as text. "),
                ($setup.confirmation_requested && $setup.vat_step && $setup.vat_answered)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      ($setup.vat_state === 'found')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.__("Please confirm your company details")), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", null, _toDisplayString($setup.vat_answer.number), 1 /* TEXT */),
                              ($setup.vat_answer.disclosed)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    ($setup.vat_answer.full_name)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createElementVNode("b", null, _toDisplayString($setup.vat_answer.full_name), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.vat_answer.address)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.vat_answer.address), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.vat_answer.postal_code || $setup.vat_answer.city)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString([$setup.vat_answer.postal_code, $setup.vat_answer.city].filter(Boolean).join(" ")), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.vat_answer.country_id)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.vat_answer.country_id), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.__("VIES confirms this VAT number without disclosing the company details")), 1 /* TEXT */))
                            ])
                          ], 64 /* STABLE_FRAGMENT */))
                        : ($setup.vat_state === 'not_found')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.__("We cannot find your VAT number")), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.__("The European VAT number check service does not seem to be active")), 1 /* TEXT */)),
                      _createCommentVNode(" The answer's own buttons: its details confirmed (FOUND), and another number for one typed here. "),
                      (($setup.vat_state === 'found' && !$setup.vat_skipped) || !$setup.stored_vat_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            ($setup.vat_state === 'found' && !$setup.vat_skipped && !$setup.vat_details_confirmed)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-primary btn-sm mr-2 mb-1",
                                  onClick: _cache[2] || (_cache[2] = $event => ($setup.confirm_vat_details()))
                                }, _toDisplayString(_ctx.__("Confirm these details")), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            ($setup.vat_state === 'found' && $setup.vat_details_confirmed)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "✓ " + _toDisplayString(_ctx.__("Details confirmed")), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (!$setup.stored_vat_number)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "btn btn-default btn-sm mb-1",
                                  onClick: _cache[3] || (_cache[3] = $event => ($setup.change_vat_number()))
                                }, _toDisplayString(_ctx.__("Change the number")), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.confirmation_requested && $setup.vat_step && $setup.vat_answered && !$setup.vat_details_confirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "vat_skipped",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.vat_skipped) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.vat_skipped]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.__("Continue without a validated VAT number")), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.confirmation_requested && !$setup.trial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "accept_terms",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.accept_terms) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.accept_terms]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_32, [
                          _createElementVNode("a", {
                            href: $setup.terms_url,
                            target: "_blank"
                          }, _toDisplayString(_ctx.__("I have read the Term of use and sales before this order")), 9 /* TEXT, PROPS */, _hoisted_33)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.confirmation_requested && !$setup.trial && $setup.var_terms_shown)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "accept_var_terms",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.accept_var_terms) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.accept_var_terms]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_37, [
                          _createElementVNode("a", {
                            href: $setup.var_terms_url,
                            target: "_blank"
                          }, _toDisplayString(_ctx.__("I have read and I accept the VAR Expert Sales condition")), 9 /* TEXT, PROPS */, _hoisted_38)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.confirmation_requested && !$setup.trial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "cart_clearance",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.cart_clearance) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.cart_clearance]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.__("I am a person authorized to commit the company for this type of order")), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.confirmation_requested && $setup.trial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "trial_terms",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.trial_terms) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.trial_terms]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.__("I have read and by checking this box I accept the terms of use of the ioi software range")), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_47, [
                  _createCommentVNode(" One main button at a time: the order's own, or while the VAT step waits for a number's check, the check. "),
                  (!$setup.trial && $setup.confirmation_requested && $setup.cart_clearance && $setup.accept_terms && (!$setup.var_terms_shown || $setup.accept_var_terms) && $setup.vat_main === 'order')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-danger text-right",
                        onClick: _cache[9] || (_cache[9] = $event => ($setup.validate_cart($setup.vat_number, $setup.trial))),
                        disabled: $setup.confirmation_clicked || $setup.vat_state === 'checking'
                      }, _toDisplayString(_ctx.__("Confirm your order")), 9 /* TEXT, PROPS */, _hoisted_48))
                    : _createCommentVNode("v-if", true),
                  (!$setup.trial && $setup.confirmation_requested && $setup.cart_clearance && $setup.accept_terms && (!$setup.var_terms_shown || $setup.accept_var_terms) && $setup.vat_main === 'verify')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary",
                        onClick: _cache[10] || (_cache[10] = $event => ($setup.check_vat_number())),
                        disabled: $setup.vat_state === 'checking'
                      }, _toDisplayString(_ctx.__("Verify my VAT number")), 9 /* TEXT, PROPS */, _hoisted_49))
                    : _createCommentVNode("v-if", true),
                  (!$setup.trial && $setup.confirmation_requested && $setup.cart_clearance && $setup.accept_terms && (!$setup.var_terms_shown || $setup.accept_var_terms) && $setup.vat_main === 'check_again')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-primary",
                        onClick: _cache[11] || (_cache[11] = $event => ($setup.check_vat_number())),
                        disabled: $setup.vat_state === 'checking'
                      }, _toDisplayString(_ctx.__("Check again")), 9 /* TEXT, PROPS */, _hoisted_50))
                    : _createCommentVNode("v-if", true),
                  ($setup.trial && $setup.confirmation_requested && $setup.trial_terms)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "btn btn-danger text-right",
                        onClick: _cache[12] || (_cache[12] = $event => ($setup.validate_cart($setup.vat_number, $setup.trial))),
                        disabled: $setup.confirmation_clicked
                      }, _toDisplayString(_ctx.__("Confirm your trial request")), 9 /* TEXT, PROPS */, _hoisted_51))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.vat_state === 'checking')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.__("Checking your VAT number…")), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}